import { FormattedMessage } from 'react-intl';

import VariableCard from '../VariableCard/VariableCard';

interface DatabaseVariablesPanelProps {
    mileage: number | null;
}

const DatabaseVariablesPanel = ({ mileage }: DatabaseVariablesPanelProps) => (
    <VariableCard
        name="mileage"
        value={
            mileage !== null ? (
                <>
                    {mileage.toLocaleString()}
                    <span className="text-size-11 text-color-gray margin-left-3">
                        <FormattedMessage id="intl-msg:mileage.km" />
                    </span>
                </>
            ) : (
                <span className="text-color-gray">—</span>
            )
        }
    />
);

export default DatabaseVariablesPanel;
